import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Output, ViewChild } from "@angular/core";
import { NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

@Component({
	selector: "alert",
	standalone: true,
	imports: [CommonModule],
	templateUrl: "alert.component.html",
})
export class AlertComponent {
	@ViewChild("content", { static: true }) public ngTemplate!: NgbModal;
	private modalRef!: NgbModalRef;

	private modelOptions: NgbModalOptions;
	public alertTitle: string = "";
	public okButton: boolean = true;
	public okButtonText: string = "Ok";
	public cancelButton: boolean = true;
	public cancelButtonText: string = "Cancel";
	public alertMessage: boolean = true;
	public message: string = "";
	public alertFooter: boolean = true;
	public alertHeader: boolean = true;
	public isOpen: boolean = false;
	public modalName: string = "";
	public displayItems: string[] = [];

	constructor(private modalService: NgbModal) {
		this.modelOptions = { backdrop: "static" };
	}

	@Output() public alertOutput: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() public alertCancelOutput: EventEmitter<boolean> = new EventEmitter<boolean>();

	public open(content: any) {
		this.isOpen = true;

		this.modalRef = this.modalService.open(content, this.modelOptions);
		this.modalRef.result.then(
			(result) => {
				this.isOpen = false;
				this.alertOutput.emit(true);
			},
			(reason) => {
				this.isOpen = false;
				this.alertCancelOutput.emit(false);
			}
		);
	}

	public ok() {
		this.isOpen = false;
		this.alertOutput.emit(true);
	}

	public cancel() {
		this.isOpen = false;
		this.alertCancelOutput.emit(false);
	}

	public close() {
		this.isOpen = false;
		this.modalRef.close("Close called programtically");
	}

	public reset() {
		this.cancelButton = false;
		this.cancelButtonText = "Cancel";
		this.okButton = false;
		this.okButtonText = "Ok";
		this.alertHeader = true;
		this.alertTitle = "Session Timeout Notification";
		this.alertFooter = false;
		this.message = "";
	}
}
